export const currentUser = `query GetCurrentUser($userId: [QueryArgument]) {
  users(id: $userId, limit: 1) {
    id
    email
    username
    status
  }
}`
